import CopyPromotion from './CopyPromotion';

export default CopyPromotion;
